import { DraggableAttributes } from "@dnd-kit/core";
import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { createContext } from "react";

import { ICourseDto, IStationCourseProps } from "@ryde/shared";

import { IUseCourseStation } from "./hooks-context-providers";

export interface ICourseStationContext
  extends Partial<IUseCourseStation>, Partial<IStationCourseProps> {
  courseDto?: ICourseDto;
  isDragging: boolean;
  listeners?: SyntheticListenerMap;
  attributes?: DraggableAttributes;
}
export const CourseStationContext = createContext<ICourseStationContext>({
  courseDto: undefined,
  isDragging: false,
});
